var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          on: { change: _vm.handleChange },
          model: {
            value: _vm.activeNames,
            callback: function($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames"
          }
        },
        _vm._l(_vm.requireGoodsItemDtoList, function(
          requireGoodsItemDto,
          index
        ) {
          return _c(
            "el-collapse-item",
            { attrs: { name: requireGoodsItemDto.ukKey } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "inline-block ml5" }, [
                  _c("span", { staticClass: "mr5" }, [_vm._v("请购机构：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(requireGoodsItemDto.requireComName || "无"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inline-block ml30" }, [
                  _c("span", { staticClass: "mr5" }, [_vm._v("供应商：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(requireGoodsItemDto.vendorName || "无"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inline-block ml30" }, [
                  _c("span", { staticClass: "mr5" }, [_vm._v("合同名称：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(requireGoodsItemDto.contractTitle || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sub-table-layout mt10" },
                [
                  requireGoodsItemDto.itemList != null &&
                  requireGoodsItemDto.itemList.length > 0
                    ? [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: requireGoodsItemDto.itemList,
                              border: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "名称",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goodsCatName",
                                label: "分类名称",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goodsBrandName",
                                label: "品牌名称",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "model",
                                label: "型号",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "fixedSpec",
                                label: "规格",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unit",
                                label: "单位",
                                width: "80"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "vendorName",
                                label: "供应商",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            !_vm.lowCostFlag
                              ? _c("el-table-column", {
                                  attrs: { label: "组装件", width: "100" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.asmblAccFlag
                                            ? _c("span", [_vm._v("是")])
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ])
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "含税价(元)", prop: "price" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.price != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.price.toFixed(2))
                                            )
                                          ])
                                        : _c("span", [_vm._v("0.00")])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "税率(%)", prop: "taxRate" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.taxRate != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.taxRate.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("0.00")])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "未税价(元)", prop: "ntxPrice" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.ntxPrice != null
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.ntxPrice.toFixed(2)
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("0.00")])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "请求数量",
                                align: "right",
                                width: "80"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: { type: "text", min: "0" },
                                        on: {
                                          change: function($event) {
                                            _vm.setQuantity(scope.$index, index)
                                          }
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.quantity"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "desc", label: "描述" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "left",
                                label: "操作",
                                width: "200"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.asmblAccFlag
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.addAccVoucher(
                                                    scope.$index,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("新增供应商")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !scope.row.asmblAccFlag
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "swb-btn-link",
                                              on: {
                                                click: function($event) {
                                                  _vm.addAssetVoucher(
                                                    scope.$index,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("新增供应商")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            2
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c26493e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c26493e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceRequireVoucherSplitOrder.vue
// module id = 3134
// module chunks = 0